'use client';

import { BookingSheet } from './booking-sheet';
import { createBookingLaunch } from './booking-launch';
import { toBookingVenue } from './venue-presentation';
import { dateInTimeZone } from '@/lib/zoned-date';
import type { PublicEvent, PublicVenue } from './domain';

export function TableEventBookingSheet({ venue, event, open, onOpenChange }: {
  venue: PublicVenue; event: PublicEvent; open: boolean; onOpenChange: (open: boolean) => void;
}) {
  if (!open || !event.reservationOffering) return null;
  const offering = { ...event.reservationOffering, menu: event.menu };
  const today = dateInTimeZone(new Date(), venue.timezone ?? 'UTC');
  const occurrence = [...event.occurrences].filter(o => o.date >= today).sort((a, b) => `${a.date}T${a.startTime}`.localeCompare(`${b.date}T${b.startTime}`))[0];
  const launch = createBookingLaunch({ locationSlug: venue.locationSlug, offering, date: occurrence?.date ?? today, partySize: Math.max(offering.partyMin ?? 1, Math.min(2, offering.partyMax ?? 8)), accessToken: venue.accessToken });
  return <BookingSheet key={event.id} venue={toBookingVenue(venue, offering)} initialSearch={launch.intent} onClose={() => onOpenChange(false)} />;
}
